import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ContestContainer.css";
import { Modal, Button, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import actions from "../../redux/actions";
import TeamDetailsModal, { useTeamDetailsModal } from "./TeamDetailsModal";

const contestss = [
  {
    id: 1,
    price: 5000,
    entryFee: 49,
    totalSpots: 100,
    spotsLeft: 20,
    numWinners: 10,
  },
];

const myTeamss = [{ id: 1, name: "Team A (Dhoni, Kohli, Bumrah)" }];

export default function ContestContainer({ myTeams = [], matchId }) {
  const contestData = useSelector(
    (state) => state.fantacySlice?.FnContestList?.Result,
  );
  const contests = Array.isArray(contestData) ? contestData : [];
  const userContestsRaw = useSelector(
    (state) => state.fantacySlice?.FnUserContestList?.Result,
  );
  const userContests = Array.isArray(userContestsRaw) ? userContestsRaw : [];
  const [show, setShow] = useState(false);
  const [selectedContest, setSelectedContest] = useState(null);
  const [selectedTeam, setSelectedTeam] = useState("");
  const [myContests, setMyContests] = useState([]);
  const {
    showTeamModal,
    teamDetails,
    loadingTeam,
    teamTitle,
    openTeamModal,
    closeTeamModal,
  } = useTeamDetailsModal(matchId);

  useEffect(() => {
    actions.getContestList(matchId);
    actions.getUserContestList(matchId);
  }, [matchId]);

  const saveToLocalStorage = (updatedList) => {
    localStorage.setItem("my_contests", JSON.stringify(updatedList));
  };

  const handleJoinClick = (contest) => {
    setSelectedContest(contest);
    setSelectedTeam("");
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedContest(null);
    setSelectedTeam("");
  };

  const getJoinedContest = (contestId) => {
    return userContests?.find((uc) => uc.ContestId === contestId);
  };

  const getTeamName = (teamId) => {
    const team = myTeams?.find((t) => t.Id === teamId);
    return team?.TeamName || "Unknown Team";
  };

  const handleConfirmJoin = async () => {
    try {
      if (!selectedTeam) {
        alert("Please select a team before joining!");
        return;
      }

      const alreadyJoined = myContests.some(
        (item) => item.Id === selectedContest.Id,
      );

      if (alreadyJoined) {
        alert("You have already joined this contest!");
        setShow(false);
        return;
      }

      // find selected team
      const selectedTeamObj = myTeams.find(
        (team) => team.TeamName === selectedTeam,
      );

      if (!selectedTeamObj) {
        alert("Team not found!");
        return;
      }

      const payload = {
        UserId: localStorage.getItem("userId") || "",
        ContestId: selectedContest.Id,
        MatchId: selectedTeamObj.MatchId,
        TeamId: selectedTeamObj.Id,
      };

      const { data, status } = await actions.JoinContest(payload);

      console.log("JoinContestResponse", { status, data });

      if (status === 200 && data?.Status) {
        const joinedContest = {
          ...selectedContest,
          joinedTeam: selectedTeam,
          joinedAt: new Date().toISOString(),
        };

        const updatedList = [...myContests, joinedContest];
        setMyContests(updatedList);
        // saveToLocalStorage(updatedList);

        alert(
          ` ${data.Result}\nYou joined Point ${selectedContest.PrizePool} contest with ${selectedTeam} for Point ${selectedContest.entry_fee}`,
        );
        actions.getUserContestList(matchId);

        setShow(false);
      }
      if (status === 200 && !data?.Status) {
        alert(`${data.Result}`);
      }
    } catch (error) {
      console.error("JoinContestError:", error);

      const message =
        error?.response?.data?.Result ||
        error?.message ||
        "Something went wrong";

      alert(`${message}`);
    }
  };

  const handleLeaveContest = (Id) => {
    const updatedList = myContests.filter((c) => c.Id !== Id);
    setMyContests(updatedList);
    // saveToLocalStorage(updatedList);
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-3 text-primary">🏏 Available Contests</h3>

      <div className="row g-4">
        {contests.length === 0 ? (
          <p className="text-center text-white-50 mt-4">No data found</p>
        ) : (
          contests.map((contest, idx) => {
            const totalTeams = Number(contest.TotalTeam) || 0;

            return (
              <div key={idx} className="col-md-4 col-sm-6">
                <div className="contest-card shadow-sm position-relative">
                  <span className="contest-name">{contest.contest_name}</span>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="contest-price">
                      Prize Pool Point{" "}
                      {Number(contest.PrizePool).toLocaleString()}
                    </span>
                    <span className="contest-entry">
                      Entry Point <b>Point {contest.entry_fee}</b>
                    </span>
                  </div>

                  <div className="d-flex justify-content-between small mb-3">
                    <span>{totalTeams} Teams Joined</span>
                  </div>

                  <button
                    className="btn btn-danger w-100 contest-btn"
                    onClick={() => handleJoinClick(contest)}
                  >
                    Join Now
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* My Contests Section */}
      {userContests?.length > 0 && (
        <div className="mt-5">
          <h3 className="mb-3 text-success">My Contests</h3>

          {Array.isArray(userContests) &&
            userContests.map((uc, idx) => {
              const contest = contests.find(
                (c) => String(c.Id) === String(uc.ContestId),
              );

              const teamName = getTeamName(uc.TeamId);

              if (!contest) return null;

              return (
                <div key={idx} className="p-3 border rounded mb-2 contest-card">
                  <div className="d-flex justify-content-between">
                    <div>
                      <b>Point {contest.PrizePool}</b> -{contest.contest_name}-
                      Joined with {teamName}
                      <br />
                      <small>Entry Point: Point {contest.entry_fee}</small>
                    </div>

                    <Button
                      variant="outline-info"
                      size="sm"
                      title="View Team"
                      onClick={() => openTeamModal(uc.TeamId, teamName)}
                    >
                      👁
                    </Button>
                  </div>
                </div>
              );
            })}
        </div>
      )}

      {/* Join Modal */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Join Contest</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedContest ? (
            <>
              <p>
                <b>Prize Pool:</b> Point {selectedContest.PrizePool}
              </p>
              <p>
                <b>Entry Fee:</b> Point {selectedContest.entry_fee}
              </p>
              <p>
                <b>Teams Joined:</b> {selectedContest.TotalTeam}
              </p>

              <Form.Group className="mt-3">
                <Form.Label>Select Your Team</Form.Label>
                <Form.Select
                  value={selectedTeam}
                  onChange={(e) => setSelectedTeam(e.target.value)}
                >
                  <option value="">-- Choose a Team --</option>
                  {myTeams.map((team) => (
                    <option key={team.Id} value={team.TeamName}>
                      {team.TeamName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </>
          ) : (
            <p>No contest selected.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleConfirmJoin}>
            Confirm & Join
          </Button>
        </Modal.Footer>
      </Modal>

      <TeamDetailsModal
        show={showTeamModal}
        onHide={closeTeamModal}
        title={teamTitle}
        loading={loadingTeam}
        players={teamDetails}
      />
    </div>
  );
}
